var City = City || {};

(function (){
  /**
   * 市区町村を返却
   */
  City.find = function(pref) {
    var defer = $.Deferred();
    $.ajax({
      url: '/service/cities.json',
      method: 'GET',
      data: {
        pref: pref,
      },
      success: defer.resolve,
      error: defer.reject
    });
    return defer.promise();
  }
})();
